// utils functions
const handleFiltersData = optionValues => {
    return optionValues.map(e => {
        const newOptions = e.options.map(el => {
            return {
                ...el,
                value: el.id || el.sp_key,
                name: el.name,
                id: el.id || el.sp_key
            };
        });

        return {
            ...e,
            selectedOptions: [],
            filterId: e.id || e.sp_key,
            type: 'checkbox',
            options: newOptions
        };
    });
};

const handleCategoryFilters = categoryFilters => {
    const updatedCategoryFilters = categoryFilters.map(category => {
        return {
            ...category,
            value: category.id,
            name: category.name
        };
    });

    return [
        {
            selectedOptions: [],
            id: 'categoryId',
            filterId: 'categoryId',
            name: 'category',
            sp_key: 'categoryId',
            type: 'checkbox',
            options: updatedCategoryFilters
        }
    ];
};

const handleBrandsFilters = brandsFilters => {
    const updatedBrandsFilters = brandsFilters.map(brand => {
        return {
            ...brand,
            sp_key: parseFloat(brand.id),
            value: brand.id,
            name: brand.name
        };
    });

    return [
        {
            selectedOptions: [],
            id: 'brand_id',
            filterId: 'brand_id',
            name: 'brandsTitle',
            sp_key: 'brand_id',
            type: 'checkbox',
            options: updatedBrandsFilters
        }
    ];
};

const getPriceDataItem = (priceData, priceFromQuery) => {
    // const fromPrice = Number.isNaN(parseFloat(priceData.from)) ? 0 : parseFloat(priceData.from);
    // const toPrice = Number.isNaN(parseFloat(priceData.to)) ? 100 : parseFloat(priceData.to);

    return {
        filterId: 'price',
        name: 'price',
        type: 'range',
        min: priceData[0],
        max: priceData[1],
        selectedFrom: priceFromQuery[0],
        selectedTo: priceFromQuery[1]
    };
};

const theState = {
    filters: [],
    promoFilters: [],
    priceRange: [],
    activeParametersOptions: [],
    isRangeSliderTriggered: false,
    statusFilter: [],
    sortingOptions: [
        {
            name: 'sortPriorityMinus',
            value: 'sort_priority-'
        },
        {
            name: 'defaultSortingType',
            value: 'newer+'
        },
        {
            name: 'sortPriceMinus',
            value: 'price-'
        },
        {
            name: 'sortPricePlus',
            value: 'price+'
        },
        {
            name: 'sortNameMinus',
            value: 'name-'
        },
        {
            name: 'sortNamePlus',
            value: 'name+'
        }
    ],
    sortingType: null,
    minMaxData: [],
    // Bad pattern of using this kinds of flags for modals, require's a modals infrastructure
    showMobileSorting: false,
    showMobileFiltering: false,
    showCasaMobileFiltering: false,
    showCasaMobileSorting: false
};

const store = {
    namespaced: true,
    state() {
        return theState;
    },
    getters: {
        filters: state => state.filters,
        getStatusFilter: state => state.statusFilter,
        priceFilter: state => {
            const priceFilter = state.filters.find(f => f.type === 'range') || null;
            return priceFilter;
        },
        getMinMxData: state => state.minMaxData,
        priceRange: state => state.priceRange,
        activeParametersOptions: state => state.activeParametersOptions,
        activeFiltersToSend: state => {
            const rawFilters = state.activeParametersOptions;
            let newFilters = rawFilters.map(f => {
                return { [f.type]: f.options };
            });

            newFilters = [...newFilters];
            if (state.isRangeSliderTriggered) {
                newFilters = [{ price: [state.priceRange[0], state.priceRange[1]] }, ...newFilters.filter(f => !f.price)];
            }
            return newFilters;
        },
        sortingType: (state, getters, rootState, rootGetters) => {
            const defaultSorting = rootGetters['global/getDefaultSorting'];
            const defaultSortingByPriority = rootGetters['global/getDefaultSortByPriority'];

            if (state.sortingType) {
                return state.sortingType;
            }

            if (defaultSorting === 'sort_priority-' && defaultSortingByPriority) {
                return defaultSorting;
            }

            if (defaultSorting === 'sort_priority-' && !defaultSortingByPriority) {
                return 'newer+';
            }

            return defaultSorting;
        },
        sortingOptions: (state, getters, rootState, rootGetters) => {
            const showSortPriority = rootGetters['global/getDefaultSortByPriority'];
            if (!showSortPriority) {
                return state.sortingOptions.filter(option => option.name !== 'sortPriorityMinus');
            }
            return state.sortingOptions;
        },
        showMobileSorting: state => state.showMobileSorting,
        showMobileFiltering: state => state.showMobileFiltering,
        showCasaMobileFiltering: state => state.showCasaMobileFiltering,
        showCasaMobileSorting: state => state.showCasaMobileSorting,
        getPromoFilters: state => state.promoFilters,
        getIsRangeSliderTriggered: state => state.isRangeSliderTriggered,
        getActivePriceRange: state => {
            const price = state.activeParametersOptions?.find(item => item.type === 'price');
            if (price) {
                return [price.options[0], price.options[1]];
            }
            return [];
        }
    },
    mutations: {
        CLEAR_STATE: (state, _) => {
            Object.keys(state).forEach(key => {
                state[key] = theState[key];
            });
        },
        SET_FILTERS: (state, items) => {
            const priceFilter = items.find(f => f.type === 'range') || null;
            const priceFromQuery = state.activeParametersOptions.find(f => f.type === 'price') || null;

            state.filters = items;

            if (priceFilter) state.priceRange = [priceFilter.selectedFrom, priceFilter.selectedTo];
            if (priceFromQuery) state.priceRange = [priceFromQuery.options[0], priceFromQuery.options[1]];
        },
        SET_ACTIVE_PARAMETERS_OPTIONS: (state, items) => (state.activeParametersOptions = items),
        SET_STATUS_FILTER: (state, data) => (state.statusFilter = data),
        SET_PRICE_RANGE: (state, data) => (state.priceRange = data),
        SET_SORTING_TYPE: (state, type) => (state.sortingType = type),
        SET_SHOW_MOBILE_SORTING: (state, flag) => (state.showMobileSorting = flag),
        SET_SHOW_MOBILE_FILTERING: (state, flag) => (state.showMobileFiltering = flag),
        SET_PROMO_FILTERS: (state, items) => (state.promoFilters = items),
        SET_IS_RANGE_SLIDER_TRIGGERED: (state, flag) => (state.isRangeSliderTriggered = flag),
        SET_SHOW_CASA_MOBILE_FILTERING: (state, flag) => (state.showCasaMobileFiltering = flag),
        SET_SHOW_CASA_MOBILE_SORTING: (state, flag) => (state.showCasaMobileSorting = flag),
        SET_MIN_MAX_DATA: (state, data) => (state.minMaxData = data)
    },
    actions: {
        clearState: ({ commit }) => commit('CLEAR_STATE'),
        setMinMaxData: ({ commit }, data) => commit('SET_MIN_MAX_DATA', data),
        setFilters: ({ commit }, items) => commit('SET_FILTERS', items),
        setPriceRange: ({ commit }, data) => {
            commit('SET_PRICE_RANGE', data);
        },
        setActiveParametersOptions: ({ commit }, items) => commit('SET_ACTIVE_PARAMETERS_OPTIONS', items),
        setSortingType: ({ commit }, type) => commit('SET_SORTING_TYPE', type),
        setShowMobileSorting: ({ commit }, flag) => commit('SET_SHOW_MOBILE_SORTING', flag),
        setShowMobileFiltering: ({ commit }, flag) => commit('SET_SHOW_MOBILE_FILTERING', flag),
        setFiltersData: ({ commit, state }, filtersData) => {
            const optionValues = filtersData?.optionsValues || [];
            const minAndMaxValues = state.minMaxData || null;
            const categoryFilters = filtersData?.category_filters || null;
            const priceFromQuery = state.activeParametersOptions.find(f => f.type === 'price')?.options || minAndMaxValues;
            const brandsFilters = filtersData?.brands || [];

            let newFilters = [];

            commit('SET_PROMO_FILTERS', filtersData?.promo_filters || []);
            commit('SET_STATUS_FILTER', filtersData?.status_filter);

            // Сначала обрабатываем optionValues если они есть
            if (optionValues.length) {
                newFilters = handleFiltersData(optionValues);
            }

            if (brandsFilters?.length) {
                newFilters = [...handleBrandsFilters(brandsFilters), ...newFilters];
            }

            // Добавляем category_filters и brands, не перезаписывая предыдущие фильтры
            if (categoryFilters) {
                newFilters = [...handleCategoryFilters(categoryFilters), ...newFilters];
            }

            // Добавляем фильтр цены если есть
            if (minAndMaxValues) {
                newFilters = [getPriceDataItem(minAndMaxValues, priceFromQuery), ...newFilters];
            }

            commit('SET_FILTERS', newFilters);
        },
        setFiltersFromQuery: ({ commit, state, dispatch }, filtersFromQuery) => {
            if (!filtersFromQuery) {
                commit('SET_ACTIVE_PARAMETERS_OPTIONS', []);
                return;
            }

            const filtersArray = [];
            let priceRangeFromQuery = null;

            const parts = filtersFromQuery.split(/,(?=[a-zA-Z0-9_]+:)/);

            if (parts) {
                parts.forEach(pair => {
                    // Разделение каждой пары по символу `:`
                    const [key, valuesString] = pair.split(':');
                    if (key && valuesString) {
                        // Преобразование строки значений в массив чисел
                        const values = valuesString.split(',').map(Number);

                        filtersArray.push({
                            type: parseFloat(key) ? parseFloat(key) : key,
                            options: values
                        });

                        if (key === 'price') {
                            priceRangeFromQuery = values;
                        }
                    }
                });
            }

            commit('SET_ACTIVE_PARAMETERS_OPTIONS', filtersArray);
            if (priceRangeFromQuery) {
                commit('SET_PRICE_RANGE', priceRangeFromQuery);
            }
        }
    }
};

export default store;
